import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { IFlight } from '../../flights/flight';
import { FlightService } from '../../flights/flight.service';

@Component({
  selector: 'app-find-flight',
  templateUrl: './find-flight.component.html',
  styleUrls: ['./find-flight.component.css']
})
export class FindFlightComponent implements OnInit {
  flights: IFlight[] = [];
  loaded = true;
  @Input() mFlightNumber = '';
  @Output() chooseFlight = new EventEmitter<IFlight>();
  constructor(private flightService: FlightService) {}

  ngOnInit() {
    this.onSearch();
  }

  getPage(page: number, filterProps: any = {}, orderStr?: string) {
    this.loaded = false;
    let params = { itemsPerPage: 99999, page: page };
    params = Object.assign(params, filterProps);
    this.flightService.getFlights(params, orderStr).subscribe(res => {
      this.flights = res.body;
      this.loaded = true;
    });
  }

  onSearch() {
    const filterProps = {
      flightNumber: this.mFlightNumber
    };
    this.getPage(1, filterProps);
  }

  onChooseFlight(flight: IFlight) {
    this.chooseFlight.emit(flight);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/find-flight/find-flight.component.ts